import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
//import { LiquidCache } from "ngx-liquid-cache";
import { identity, Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { BaseUrlHelperService } from "../helper/baseUrlHelper.service";
import { NbcLoggerService } from "../logger/nbc-logger.service";

@Injectable({
    providedIn: "root",
})
export class LookUpService {
    userName: any | undefined;

    constructor(
        private http: HttpClient,
        private _apiroot: BaseUrlHelperService,
        private log: NbcLoggerService
    ) {}

    //@LiquidCache("getEmployeeTypes")
    getEmployeeTypes(): Observable<any> {
        this.log.trace("timesheetLookUpService: get Employee Types");
        return this.http
            .get(
                this._apiroot.baseUrl +
                    "talentPayroll/lookups/employeeTypes/get"
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    //@LiquidCache("getNetworks")
    getNetworks(): Observable<any> {
        this.log.trace("timesheetLookUpService: get Networks");
        return this.http
            .get(this._apiroot.baseUrl + "talentPayroll/lookups/networks/get")
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    //@LiquidCache("getSports")
    getSports(): Observable<any> {
        this.log.trace("timesheetLookUpService: get Sports");
        return this.http
            .get(this._apiroot.baseUrl + "talentPayroll/lookups/sports/get")
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    //@LiquidCache("getPayrollProviders")
    getPayrollProviders(): Observable<any> {
        this.log.trace("timesheetLookUpService: get Payroll Providers");
        return this.http
            .get(
                this._apiroot.baseUrl +
                    "talentPayroll/lookups/payrollProviders/get"
            )

            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    //@LiquidCache("getChargeCodeTypes")
    getChargeCodeTypes(): Observable<any> {
        this.log.trace("timesheetLookUpService: get ChargeCode Types");
        return this.http
            .get(
                this._apiroot.baseUrl +
                    "talentPayroll/lookups/chargeCodeTypes/get"
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    //@LiquidCache("getWorkStates")
    getworkStates(): Observable<any> {
        this.log.trace("timesheetLookUpService: get WorkStates");
        return this.http
            .get(this._apiroot.baseUrl + "talentPayroll/lookups/workStates/get")
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    //@LiquidCache("getDayTypes")
    getDayTypes(): Observable<any> {
      this.log.trace("timesheetLookUpService: get Day types");
      return this.http
        .get(this._apiroot.baseUrl + "talentPayroll/lookups/daytypes/get")
        .pipe(
          catchError((err) => {
            return throwError(err);
          })
        );
    }

    //@LiquidCache("getDefaultConfigs")
    getDefaultConfigs(): Observable<any> {
        this.log.trace("timesheetLookUpService: get WorkStates");
        return this.http
            .get(
                this._apiroot.baseUrl +
                    "talentPayroll/lookups/defaultConfigs/get"
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    //@LiquidCache("getunionCodes")
    getunionCodes(): Observable<any> {
        this.log.trace("timesheetLookUpService: get UnionCodes");
        return this.http
            .get(this._apiroot.baseUrl + "talentPayroll/lookups/unionCodes/get")

            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    //@LiquidCache("getDefaultPageSize")
    getDefaultPageSize(): Observable<any> {
        this.log.trace("timesheetLookUpService: get default page size");
        return this.http
            .get(
                this._apiroot.baseUrl +
                    "talentPayroll/lookups/defaultPageSize/get"
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    //@LiquidCache("getPayrollDefaults")
    getPayrollDefaults(buId): Observable<any> {
        this.log.trace("talentPayrollDefaultService: get Payroll Defaults");
        return this.http
            .get(
                this._apiroot.baseUrl +
                    "talentPayroll/payrollDefaults/get/" +
                    buId
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    searchGlAccounts(term): Observable<any> {
        this.log.trace("calling getGlAccounts:" + JSON.stringify(term));
        return this.http
            .get(this._apiroot.baseUrl + "payroll/glaccounts?term=" + term)
            .pipe(
                map((data: any) => (data && data.reference) || []),
                catchError((err) => {
                    return [];
                })
            );
    }

    searchbynameHcmData(term): Observable<any> {
        this.log.trace("searching a contacts name " + JSON.stringify(term));
        return this.http
            .get(
                this._apiroot.baseUrl + "contacts/searchbynamesso/?term=" + term
            )
            .pipe(
                map((data: any) => (data && data.reference) || []),
                catchError((err) => {
                    return [];
                })
            );
    }

    //Query For Report filters
    getreportQuery(
        query,
        currentPage,
        pageSize,
        totalRecords,
        businessUnitId,
        departmentId
    ) {
        return {
            Batch_id: null,
            BUBeingUsed: businessUnitId || 0,
            currentPage: currentPage || 1,
            pageSize: pageSize || 10,
            totalRecords: totalRecords || 0,
            sortByColumn: "",
            reverseSort: false,
            searchOptionId: null,
            searchTerm: null,
            employeeType: query.employeeType
                .map(function (elem) {
                    return elem.id;
                })
                .join(","),
            workState: "",
            queueStatus: "ALL",
            workflowStatus: departmentId,
            eventShowName: query.eventShow,
            contactName: query.contact,
            sso: query.sso,
            perNer: query.perNer,
            wbse: query.wbse,
            glAccount: query.glAccount,
            CostCenter: query.wbse,
            LoggedInDept: departmentId,
            sports: query.sports
                .map(function (elem) {
                    return elem.id;
                })
                .join(","),
            networks: query.networks
                .map(function (elem) {
                    return elem.id;
                })
            .join(","),
          daytypes: query.daytypes
            .map(function (elem) {
              return elem.id;
            })
            .join(","),
            unionCode: query.unionCode
                .map(function (elem) {
                    return elem.description;
                })
                .join(","),
            businessUnits: query.businessUnits
                .map(function (elem) {
                    return elem.id;
                })
                .join(","),
            timecardDateFrom: query.dateRangeStartDate,
            timecardDateTo: query.dateRangeEndDate,
            processedDate: query.processDateRangeStartDate,
            processedToDate: query.processDateRangeEndDate,
          wbseCostCenter: query.wbseCostCenter,
          aftra: query.aftra[0]?.description,
        };
    }

    transactionSummaryReport(talentTimesheetQuery, reportName) {
        this.log.trace("reportService: Pending Onboarding Report");
        const createdDateTime = new Date();
        this.userName =
            window.preload.user.firstName + " " + window.preload.user.lastName;
        const inputInfo = {
            query: talentTimesheetQuery,
            jsonData: {
                reportName: reportName,
                createdBy: this.userName,
                createdDate: createdDateTime.toDateString(),
                createdTime: createdDateTime.toTimeString(),
                hours: createdDateTime.getHours(),
                minutes: createdDateTime.getMinutes(),
                timeZone: createdDateTime.getTimezoneOffset(),
            },
        };
        return this.http.post(
            this._apiroot.baseUrl +
                "talentPayroll/timecards/transactionSummary/",
            inputInfo,
            {
                responseType: "arraybuffer",
                headers: {
                    "Content-type": "application/json",
                    Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                },
            }
        );
    }

    //Pending  Onboarding Report
    pendingOnboardingReport(businessUnitId) {
        this.log.trace("reportService: Pending Onboarding Report");
        const createdDateTime = new Date();
        const userName =
            window.preload.user.firstName + " " + window.preload.user.lastName;
        return this.http.post(
            this._apiroot.baseUrl +
                "talentPayroll/timecards/" +
                businessUnitId +
                "/onboarding",
            {
                createdBy: userName,
                createdDate: createdDateTime.toDateString(),
                createdTime: createdDateTime.toTimeString(),
                hours: createdDateTime.getHours(),
                minutes: createdDateTime.getMinutes(),
                seconds: createdDateTime.getSeconds(),
                timeZone: createdDateTime.getTimezoneOffset(),
            },
            {
                responseType: "arraybuffer",
                headers: {
                    "Content-type": "application/json",
                    Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                },
            }
        );
    }
}
